module.exports = __webpack_public_path__ + "img/logo_teamchile.48933e22.png";